import React from "react";
import { CustomAccordion, CustomTooltip, icon, IconComponent } from "../../../../../../../../../common/components";
import styles from "./DeliverablesPhasesList.module.css";
import { DeliverablesList } from "..";
import { isNonEmptyArray } from "../../../../../../../../../common/utils";

export default function DeliverablesPhasesList({
	hasFilters,
	onAllocate,
	onExpandPhase,
	phases,
	reqId,
	setSelectedCount,
	showSelected,
}) {
	return (
		<>
			{isNonEmptyArray(phases) &&
				phases.map((phase) => {
					const isExpanded = phase?.deliverablesCount > 0 || phase?.deliverables?.length > 0;
					const phaseLocked = Boolean(phase.lockedOrArchived || phase.phaseLockedOrArchived || phase.locked);
					return (
						<CustomAccordion
							key={phase.phaseId}
							className={styles.accordionContent}
							defaultOpen={hasFilters || showSelected || phase.defaultExpanded}
							header={
								<CustomTooltip showWhenOverflow title={phase?.phaseName}>
									<div
										className={styles.line}
										data-phase-locked={phaseLocked}
										data-testid={`req.phase.${phase.phaseId}`}
									>
										{phase?.phaseName}
										{phaseLocked && <IconComponent color="var(--grey-500)" icon={icon.faLock} />}
									</div>
								</CustomTooltip>
							}
							iconColor="var(--grey-500)"
							onExpand={() => {
								if (isExpanded) {
									onExpandPhase({ expandablePhase: phase });
								}
							}}
						>
							{(isExpanded && (
								<DeliverablesList
									deliverables={phase.deliverables}
									phaseLocked={phaseLocked}
									reqId={reqId}
									setSelectedCount={setSelectedCount}
									showSelected={showSelected}
									onAllocate={onAllocate}
								/>
							)) ||
								null}
						</CustomAccordion>
					);
				})}
		</>
	);
}
